@import "../../../containers/styles.module.scss";

.container {
  padding-bottom: calc(100vh - 768px);

  &__form_group {
    & > label {
      font-size: 20px;
      font-weight: bold;
    }
  }
}

.answersContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 75%;
  margin-right: 5.5%;
  margin-top: 15px;
}

.answer {
  display: flex;
  align-items: center;
  padding: 5px;
  margin-bottom: 20px;
  border: 1px solid black;
  span {
    margin-right: 10px;
    font-weight: bold;
    font-size: medium;
  }
}

.img {
  max-width: 130px;
  max-height: 130px;
}
